import { USE_OVERFLOW_MENU_MENU_TRIGGER_ATTR } from '../hooks';
export var TOGGLE_BUTTON_GROUP_MENU_TRIGGER_ATTR = USE_OVERFLOW_MENU_MENU_TRIGGER_ATTR;
